import { AbsoluteNumber } from '@app/features/apply-react-signing/components/FieldRenderer/types';

export function createAbsoluteNumber(value: number): AbsoluteNumber {
  return value as AbsoluteNumber;
}
